export default {
  "p_comments:delete": "Comments: Delete",
  "p_comments:edit": "Comments: Edit",
  "p_comments:create": "Comments: Create",
  "p_comments:view": "Comments: View",

  "p_price+proposals+++delete": "Price proposals: Delete",
  "p_price+proposals+++edit": "Price proposals: Edit",
  "p_price+proposals+++create": "Price proposals: Create",
  "p_price+proposals+++view": "Price proposals: View",

  "p_change+protected+statuses": "Change protected statuses",

  "p__request+rate": "Price requests",
  "p_delete+requests": "Requests: Delete",
  "p_editing+requests": "Requests: Edit",
  "p_create+requests": "Requests: Create",
  "p_view+requests": "Requests: View",

  "p_edit+contact": "Contacts: Edit",

  "p_change+credit+limit": "Credit limit: Change",

  "p_delete+clients": "Clients: Delete",
  "p_editing+clients": "Clients: Edit",
  "p_create+clients": "Clients: Create",
  "p_view+clients": "Clients: View",

  "p_delete+carriers": "Carriers: Delete",
  "p_editing+carriers": "Carriers: Edit",
  "p_create+carriers": "Carriers: Create",
  "p_view+carriers": "Carriers: View",

  "p_documents(transportation,+cmr,+photo):+view":
    "Documents (transportation, CMR, photo): View",

  "p_other:+view": "Other: View",
  "p_act:+view": "Act: View",

  "p_other:+create": "Other: Create",
  "p_other:+delete": "Other: Delete",
  "p_other:+edit": "Other: Edit",

  "p_acts:+create": "Acts: Create",
  "p_acts:+delete": "Acts: Delete",
  "p_acts:+edit": "Acts: Edit",

  "p_edit+paid+invoices": "Paid invoices: Edit",

  p_delete: "Delete",
  p_edit: "Edit",
  p_create: "Create",
  p_view: "View",

  "p_edit+paid+invoices_2": "Paid invoices: Edit",
  p_delete_2: "Delete",
  p_edit_2: "Edit",
  p_create_2: "Create",
  p_view_2: "View",

  "p_edit+order+status+history": "Order status history: Edit",
  "p_view+order+status+history": "Order status history: View",

  "p_delete+financial": "Financial: Delete",
  "p_edit+financial": "Financial: Edit",
  "p_view+financial": "Financial: View",

  "p_edit+freight": "Freight: Edit",
  "p_view+freight": "Freight: View",

  p_margin: "Margin",
  p_total: "Total",

  "p_trips+in+order": "Trips in order",

  "p_documents(transportation,+cmr,+phtoto)":
    "Documents (transportation, CMR, photo)",

  "p_cargo+information": "Cargo information",
  "p_client+information": "Client information",

  p_profit: "Profit",

  "p_delete+orders": "Orders: Delete",
  "p_edit+status": "Status: Edit",
  "p_editing+orders": "Orders: Edit",
  "p_create+orders": "Orders: Create",
  "p_view+orders": "Orders: View",

  "p_delete+trips": "Trips: Delete",
  "p_update+trips": "Trips: Update",
  "p_create+trips": "Trips: Create",
  "p_trips+view": "Trips: View",

  "p_your+own+departments+orders": "Your department's orders",
  "p_your+own+orders": "Your orders",
  "p_all+orders": "All orders",

  "p_your+own+departments+requests": "Your department's requests",
  "p_your+own+requests": "Your requests",
  "p_all+requests": "All requests",

  "p_your+own+departments+clients": "Your department's clients",
  "p_your+own+clients": "Your clients",
  "p_all+clients": "All clients",

  "p_your+own+departments+carriers": "Your department's carriers",
  "p_your+own+carriers": "Your carriers",
  "p_all+carriers": "All carriers",

  "p_your+own+departments+trips": "Your department's trips",
  "p_your+own+trips": "Your trips",
  "p_all+trips": "All trips",

  l_Username: "Username",
  l_User_password: "User password",
  l_Forgot_password: "Forgot password",
  l_Login: "Log in",
  l_Sign_out: "Sign out",
  l_EmailorPasswordisWrong: "Email or password is wrong",
  l_Requests: "Requests",
  l_Orders: "Orders",
  l_Order_code_referral: "Referral code",
  l_Order_code_referral_short: "Ref. code",
  l_New_status: "New status",
  l_Finance: "Finance",
  l_Clients: "Clients",
  l_Carriers: "Carriers",
  l_New_post: "New post",
  l_Settings: "Settings",
  l_Request_statuses: "Request statuses",
  l_Request_purposes: "Request purposes",
  l_Request_sources: "Request sources",
  l_Position_of_contact_persons: "Position of contact persons",
  l_Organization: "Organization",
  l_Templates: "Templates",
  l_Request_is_received: "Request is received",
  l_European_country: "European country",
  l_Request_number: "Request number",
  l_New_vat_rate: "New vat rate",
  l_Less: "Less",
  l_Business_number: "Type number",
  l_More: "More",
  l_Classifiers: "Classifiers",
  l_Position_of_contacts: "Position of contacts",
  l_System: "System",
  l_Classifier: "Classifier",
  l_Cargo_information: "Cargo information",
  l_Additional_info: "Additional info",
  l_Vat_rate: "VAT rate",
  l_Extremely_urgent: "Extremely urgent",
  l_Request_purpose: "Request purpose",
  l_Log: "Log",
  l_Companies: "Companies",
  l_Departments: "Departments",
  l_Employees: "Employees",
  l_Groups_of_employees: "Groups of employees",
  l_Company_name: "Company name",
  l_Name_in_original: "Name in original",
  l_Company_code: "Company code",
  l_VAT_code: "VAT code",
  l_Address: "Address",
  l_Seller: "Seller",
  l_Logistician: "Logistician",
  l_Address_for_correspondence: "Address for correspondence",
  l_Banks: "Banks",
  l_New_client: "New client",
  l_New_order: "New order",
  l_Cargo_statuses: "Cargo statuses",
  l_Client_types: "Client types",
  l_Organization_section: "Organization section",
  l_Document_statuses: "Document statuses",
  l_Order_statuses: "Order statuses",
  l_Price_proposals: "Price Proposals",
  l_Railway_stations: "Railway stations",
  l_Transport_types: "Transport types",
  l_Trip_statuses: "Trip statuses",
  l_VAT_rates: "VAT rates",
  l_Workers_posts: "Workers' posts",
  l_Whatsapp_notification_send: "Sending notifications to WhatsApp",
  l_Name: "Name",
  l_Unofficial_name: "Unofficial name",
  l_Branch: "Branch",
  l_Code__: "Code",
  l_Created: "Created",
  l_Post_code: "Post code",
  l_Action: "Action",
  l_Add: "Add",
  l_Update: "Update",
  l_Edit: "Edit",
  l_Submit: "Submit",
  l_Cancel: "Cancel",
  l_Are_you_sure_delete_this_task: "Are you sure delete this task?",
  l_Yes: "Yes",
  l_No: "No",
  l_Keyword: "Keyword",
  l_Search: "Search",
  l_Active: "Active",
  l_Initial: "Initial",
  l_Final: "Final",
  l_NotFound: "Not Found",
  l_Succeed: "Succeed",
  l_Segment_name: "Segment name",
  l_Segment_priority: "Segment priority",
  l_Color: "Color",
  l_By_default: "By default",
  l_Yellow: "Yellow",
  l_Green: "Green",
  l_Grey: "Grey",
  l_Red: "Red",
  l_Orange: "Orange",
  l_Status_name: "Status name",
  l_Priority: "Priority",
  l_Status_type: "Status type",
  l_Text_colour: "Text color",
  l_Background_colour: "Background color",
  l_After_setting_status: "After setting status",
  l_Message_for_seller: "Message for seller",
  l_Topic_of_the_message_for_seller_TWIG:
    "Topic of the message for seller TWIG",
  l_Name_2: "Наименование",
  l_Railway_station: "Railway station",
  l_Code: "Code",
  l_Railway: "Railway",
  l_Railway2: "Railway",
  l_Failed_to_submit: "Failed to submit",
  l_Rate: "Rate",
  l_Give_access_to_carrier: "Give access to carrier",
  l_Valid_from: "Valid from",
  l_Notify_about_expiration: "Notify about expiration",
  l_Valid_until: "Valid until",
  l_VAT_law: "VAT law",
  l_third_part_code: "Third-part code",
  l_third_part_price: "Third-part price",
  l___CountVat: "__CountVat",
  l_Other_docs: "Other documents",
  l_Transportation_orders: "Transportation orders",
  l_Overhead_docs: "Overhead documents",
  l_Request_doc: "Documents for request",
  l_Default_VAT_rate: "Default VAT rate",
  l_Error: "Error",
  l_Basic_information: "Basic information",
  l_Signatures: "Signatures",
  l_Directors_full_name: "Director's full name",
  l_In_the_name_of_whom: "In the name of whom",
  l_Post: "Post",
  l_VAT_rate: "VAT rate",
  l_RRC: "RRC",
  l_OGRN: "OGRN",
  l_Pricing_type: "Pricing type",
  l_Contact_information: "Contact information",
  l_Country: "Country",
  l_City: "City",
  l_Correspondent_information: "Correspondent information",
  l_Telephone: "Telephone",
  l_Fax: "Fax",
  l_Contact_partner: "Contact partner",
  l_Email: "Email",
  l_Website: "Website",
  l_Main_company: "Main company",
  l_Operating_account: "Operating account",
  l_Bank_code: "Bank code",
  l_Bank: "Bank",
  l_Calculations: "Расчеты",
  l_Different_invoices_for_different_currencies:
    "Different invoices for different currencies",
  l_Currency: "Currency",
  l_Correspondent_bank: "Correspondent bank",
  l_Print: "Print",
  l_Company_logotype: "Company logotype",
  l_Signature: "Signature",
  l_correspondent_account: "Сorrespondent account",
  l_Inc_VAT_price: "Inc VAT price",
  l_Ex_VAT_price: "Ex VAT price",
  l_Bank_name: "Bank name",
  l_Expences: "Expences",
  l_Wagon_number: "Wagon number",
  l_Margin: "Margin",
  l_Click_or_drag_ile_to_this_area_to_upload:
    "Click or drag file to this area to upload",
  l_Department_name: "Department name",
  l_Department_prefix: "Department prefix",
  l_Company: "Company",
  l_Request_status: "Request status",
  l_Received_payment: "Received payment",
  l_Total_issued_invoice: "Total issued invoice",
  l_Login_email: "Login email",
  l_Groups: "Groups",
  l_Name_Surname: "Name, Surname",
  l_Surname: "Surname",
  l_Date_of_last_visit: "Date of last visit",
  l_Mail_settings: "Mail settings",
  l_Password: "Password",
  l_Reset_your_password: "Are you sure you want to reset your password?",
  l_For_bonus: "% for bonus, %",
  l_Employee_prefix: "Employee prefix",
  l_Department: "Department",
  l_Term: "Term",
  l_New_payment_term: "New payment term",
  l_Access_rights: "Access rights",
  l_All: "All",
  l_Packagings: "Packagings",
  l_YourOwnDepartment: "Your Own Department",
  l_YourOwn: "Your Own",
  l_Contract_for_trips: "Contract for trips",
  l_History_payment: "History of payment",
  l_Received: "Payment date",
  l_New_calculation: "New calculation",
  l_Expence: "Expence",
  l_Name_of_the_kind_of_packing: "Name of the kind of packing",
  l_Request_date: "Request date",
  l_Exprired: "Expired",
  l_Contract_partner: "Contract partner",
  l_Refusal_reason: "The reason o the refusal of the request",
  l_Are_you_sure_to_cancel:
    "Are you sure, that you want to change request status to 'Unconfirmed'?",
  l_Unlimited_access: "Unlimited access",
  l_The_reason_of_refusal: "The reason of refusal of the request",
  l_Additional_information: "Additional information",
  l_Document_is_sending: "Document is sending",
  l_Sender: "Sender",
  l_Theme: "Theme",
  l_Workers_post: "Worker's posts",
  l_Different_acc_for_currency: "Different invoices for different currencies",
  l_Send: "Send",
  l_Copy: "Copy",
  l_Images_for_docs: "Images for documents",
  l_Director: "Director",
  l_Representive_name: "Representive name",
  l_Worker_post: "Worker's post",
  l_Company_prefix: "Prefix name",
  l_Stamp: "Stamp",
  l_Logo: "Logo",
  l_Sign: "Sign",
  l_Main: "Main",
  l_Cargos_and_routes: "Cargos and Routes",
  l_Trip_expenses: "Trips expenses",
  l_Destination: "Destination",
  l_Destination_time: "Destination time",
  l_Departure: "Departure",
  l_Departure_time: "Departure time",
  l_Type_of_transport: "Type of transport",
  l_Loading_place_custom: "Loading place customs",
  l_Without_stamp_and_sign: "Without stamops and sign",
  l_Have_expiration_date: "Have expiration date",
  l_Access: "Access",
  l_Country_from: "Country from",
  l_Country_to: "Country to",
  l_City_from: "City from",
  l_City_to: "City to",
  l_Confirm: "Confirm",
  l_Confirm_and_create: "Confirm and create",
  l_Payment_term: "Payment term",
  l_Total_received_invoice: "Total received invoice",
  l_New_splitting_status: "New splitting status",
  l_Total_weight: "Total weight",
  l_Add_service: "Add service",
  l_Element_rule_list: "Element in rule list",
  l_Direction: "Direction",
  l_Total_volume: "Total volume",
  l_Special_rights: "Special rights",
  l_Group: "Group",
  l_Donnot_count_in_balance: "Don't count in balance",
  l_Numeration: "Numeration",
  l_Numeration_name: "Numeration name",
  l_Numeration_for: "Numeration for",
  l_Employee: "Employee",
  l_Seperate_line_in_the_invoice: "Seperate line in the invoice",
  l_Prefix: "Prefix",
  l_Year: "Year",
  l_Month: "Month",
  l_Delimiter: "Delimiter",
  l_Number_of_digits: "Number of digits",
  l_Index: "Index",
  l_Suffix: "Suffix",
  l_View: "View",
  l_Client: "Client",
  l_Consolidation: "Consolidation",
  l_Cargos: "Cargos",
  l_Trips: "Trips",
  l_Cargos_status: "Cargos status",
  l_Salary_calculation: "Salary calculation",
  l_Show_filters: "Show filters",
  l_Order_date: "Order date",
  l_Date: "Date",
  l_Users: "Users",
  l_Documents: "Documents",
  l_Transport: "Transport",
  l_Other: "Other",
  l_Sort: "Sort",
  l_Are_you_sure_to_confirm:
    "Are you sure, that you want to confirm this request?",
  l_Order_number: "Order number",
  l_Order_status: "Order status",
  l_Loading_area: "Loading area",
  l_Unloading_area: "Unloading area",
  l_Loading_date: "Loading date",
  l_Days_of_trip: "Days of trip",
  l_Car_number: "Car Number",
  l_Freight: "Freight",
  l_Costs: "Costs",
  l_Status_characteristic: "Request characteristic",
  l_Profit: "Profit",
  l_User: "User",
  l_Deferred_payment_condition: "Deferred payment conditions",
  l_Trip_number: "Trip number",
  l_Weight: "Weight",
  l_New_request_purpose: "New request purpose",
  l_Request_purpose_name: "Request purpose name",
  l_Adding: "Adding",
  l_Volume: "Volume",
  l_Sorting: "Sorting",
  l_Reply_deadline: "Reply deadline",
  l_Total_freight: "Total freight",
  l_Change_status: "Change status",
  l_XML_unloading: "XML unloading",
  l_Payment_type_name: "Payment type name",
  l_Auto_pick_up: "Auto pickup",
  l_New_trip: "New trip",
  l_Created_at: "Date of creation",
  l_Invoice_number: "Invoice number",
  l_Car_trip: "Car trip",
  l_Managers: "Managers",
  l_Template_section: "Template section",
  l_Invoice_issued: "Invoice issued",
  l_Rail_trip: "Railway trip",
  l_Date_of_creation: "Date of creation",
  l_Trailers_number: "Trailers number",
  l_Client_type: "Client type",
  l_Pay_until: "Pay until",
  l_Price_without_VAT: "Price withoit VAT",
  l_TIN_taxpayer_ID_number_VAT: "TIN/taxpayer ID number /VAT№",
  l_Activity_area: "Activity area",
  l_Postponement_days: "Postponement days",
  l_ContactInfo: "Contact info",
  l_OKPO: "OKPO",
  l_Template_group: "Template group",
  l_Add_line: "Add line",
  l_Price_with_V: "Price with VAT",
  l_Add_template: "Add template",
  l_Document_templates_group: "Document template group",
  l_New_city: "New city",
  l_Receiver: "Receiver",
  l_Cities: "Cities",
  l_Invoice_received: "Invoice received",
  l_Click_or_drag_file_to_this_area_to_upload:
    "Click or drag file to this area to upload",
  l_TIN: "TIN",
  l_Quantity: "Quantity",
  l_Packing_type: "Packaging method",
  l_Invoicess_issued: "Issued invoice",
  l_Is_Use_nonstandard_invoice_template: "Is use nonstandard invoice template",
  l_Is_without_StampAnd_Signature: "Is without stamp and signature",
  l_Visible_for_client: "Visible for client",
  l_BIN: "BIN",
  l_Give_access_to_client: "Give access to client",
  l_Balance_of_payments: "Balance of payments",
  l_Payment_balance: "Payment balance",
  l_TRN: "TRN",
  l_Refusal_comment: "Refusal comment",
  l_Legal_address: "Legal address",
  l_Legal_name: "Legal name",
  l_Product_type: "Product type",
  l_Postal_address: "Postal address",
  l_Postal_code: "Postal code",
  l_Product: "Product",
  l_Received_date: "Received date",
  l_Payment_rules: "Payment rules",
  l_Credit_limit: "Credit limit",
  l_Payment_delay: "Payment delay",
  l_New_bank: "New bank",
  l_Is_Partial_Cargo: "Is partial cargo",
  l_Order_status_id: "Order status id",
  l_Limit_exceeded: "Limit exceeded",
  l_Deferred_payment_terms: "Deferred payment terms",
  l_Email_to_send_documents: "Email to send documents",
  l_Send_debt_remindings: "Send debt remindings",
  l_Swift: "Swift",
  l_Request_source: "Request source",
  l_PleaseEnterName: "Please Enter Name",
  l_Contact_persons_posts: "Contact persons' posts",
  l_Contact_person: "Contact person",
  l_Manager: "Manager",
  l_Days_from_the_latest_contract: "Days from the latest contract",
  l_Order_quantity: "Order quantity",
  l_Client_price: "Client price",
  l_Please_select_at_least_one_cargo: "Please select at least one cargo",
  l_Carrier_price: "Carrier price",
  l_Purchase_funnel: "Purchase funnel",
  l_Purchase_funnel_status: "Purchase funnel status",
  l_Phone: "Phone",
  l_Creation_date: "Creation date",
  l_Type_of_the_received_document: "Type of the received document",
  l_Contact_personnel: "Contact personnel",
  l_Successed: "Successed",
  l_Company_details: "Company details",
  l_Receiving_date: "Receiving date",
  l_Active_requests: "Active requests",
  l_Archive_requests: "Archive requests",
  l_Archive: "Archive",
  l_Duly_represtnted: "Duly represented...",
  l_Size: "Size",
  l_Income: "Income",
  l_Use_in_all_documents: "Use in all documents",
  l_Phone_number: "Phone number",
  l_Skype: "Skype",
  l_Fullname: "Fullname",
  l_Roles: "Roles",
  l_Work_time: "Work time",
  l_Reset: "Reset",
  l_ICQ: "ICQ",
  l_Logs: "Logs",
  l_Session_log: "Session log",
  l_Data: "Data",
  l_Delete: "Delete",
  l_ID_session: "ID Session",
  l_Brouser: "Brouser",
  l_Comments: "Comments",
  l_List_empty: "List is empty",
  l_Access_to_req: "Access to permissions",
  l_PasswordNotLessThan6Letters: "Password Not Less Than 6 Letters",
  l_Existed: "Existed",
  l_Permission_settings: "Permission settings",
  l_EmailExisted: "Email Existed",
  l_Clients_order_number: "Client's order number",
  l_Contacts: "Contacts",
  l_Default_forwarder: "Coordinator",
  l_Additional_managers: "Freight coordinator",
  l_Price: "Price",
  l_Price_with_VAT: "Price with VAT",
  l_Deferred_payment_days: "Deferred payment (days)",
  l_Deferred_payment_conditions: "Deferred payment conditions",
  l_Full_text: "Full text",
  l_Group_name: "Group name",
  l_Full_name: "Fullname",
  l_Carrier_types: "Carrier types",
  l_Group_of_employees: "Group of employees",
  l_One_or_more_content_missing: "One or more of the content is missing",
  l_Statuses: "Statuses",
  l_Invoices: "Invoices",
  l_Delivery_terms: "Delivery terms(по Инко термс 2010)",
  l_Transit_time: "Transit time",
  l_Reloading_place: "Reloading place",
  l_Order_detail: "Order detail",
  l_Tasks: "Tasks",
  l_New_carrier: "New carrier",
  l_External_trip: "External trip",
  l_Number: "Number",
  l_Number_in_carrier_system: "Number in carrier system",
  l_Choose_client: "Choose client",
  l_Initial_freight: "Initial freight",
  l_Expenses: "Expenses",
  l_Forwarders: "Forwarders",
  l_Documents_with_clients: "Documents with clients",
  l_Cargo_number: "Cargo number",
  l_Reloading_date: "Reloading date",
  l_Cargo_name: "Cargo name",
  l_Cargo_parameters: "Cargo parameters",
  l_Loading: "Loading",
  l_Is_general: "Is general",
  l_Notification: "Notification",
  l_New_payment: "New payment",
  l_There_is_nothing: "There are no notifications",
  l_Payment_amount: "Payment amount",
  l_Payment_date: "Payment date",
  l_Payment_type: "Payment type",
  l_You_dont_have_permission: "You do not have a permisiion to this action",
  l_Cash: "Cash",
  l_Cashless: "Cashless",
  l_Price_show: "Cost details",
  l_Is_automating_sending: "Is automating sending",
  l_Custom_data: "Unloading place customs",
  l_Custom_loading_data: "Loading place customs",
  l_Reloading_storage_place: "Reloading/storage place",
  l_Date_of_transhipment: "Date of transhipment",
  l_Unloading: "Unloading",
  l_Consignment_Price: "Consignment Price",
  l_New_user: "New user",
  l_Loading_place: "Loading place",
  l_Time: "Time",
  l_Save: "Save",
  l_Place_Company: "Place / Company",
  l_Trip_or_cargo_number: "No. trip/consignment",
  l_Rate_date: "Rate date",
  l_Contact_person_and_telephone: "Contact person and telephone",
  l_Loading_place_customs: "Loading place customs",
  l_To: "To",
  l_Unloading_place: "Unloading place",
  l_Unloading_place_customs: "Unloading place customs",
  l_Packing_type_quantity: "Packing type/quantity",
  l_Pallets: "Pallets",
  l_LDM: "LDM",
  l_Length: "Length",
  l_Width: "Width",
  l_Height: "Height",
  l_Partial_cargo: "Partial cargo",
  l_Cargo_additional_information: "Cargo additional information",
  l_Attributes: "Attributes",
  l_Insurance: "Insurance",
  l_Terms_of_delivery: "Terms of delivery (according to Incoterms 2010)",
  l_Transit_Time: "Transit time",
  l_Status: "Status",
  l_Unloading_date: "Unloading date",
  l_New_cargo: "New cargo",
  l_Carrier: "Carrier",
  l_Forwarder: "Forwarder",
  l_New_rail_station: "New rail station",
  l_Station: "Station",
  l_Rail_station: "Rail station",
  l_Received_invoices: "Received invoices",
  l_Cargos_and_Routes: "Cargos and Routes",
  l_Carrier_company: "Carrier company",
  l_Carrier_contract_number_with_carrier:
    "Carrier contract number with carrier",
  l_Insurance_policy_valid_until: "Insurance policy valid until",
  l_Number_in_carriers_system: "Number in carrier's system",
  l_Trip: "Trip",
  l_Terms_and_conditions_of_payment: "Terms and conditions of payment",
  l_Vehicle_number: "Vehicle number",
  l_Trailers_numbers: "Trailers numbers",
  l_Transport_type: "Transport type",
  l_Loading_method: "Loading method",
  l_Passport_number: "Passport number",
  l_Driver: "Driver",
  l_Container_number: "Container number",
  l_Sizes_L_W_H: "Sizes (L*W*H)",
  l_Amount: "Amount",
  l_Packing: "Packing",
  l_Order: "Order",
  l_Route: "Route",
  l_Change_password: "Change password",
  l_Client_to_user: "Access for clients",
  l_Notification_language: "Notification language",
  l_Cargo_status: "Cargo status",
  l_Received_invoice: "Received invoice",
  l_Expense: "Expense",
  l_Expenses_incl_VAT: "Expenses incl. VAT",
  l_Dont_count_in_balance: "Don't count in balance",
  l_Separate_line_in_the_invoice: "Separate line in the invoice",
  l_Expense_description: "Expense description",
  l_Document_name: "Document name",
  l_Document_expiration_date: "Document expiration date",
  l_Available_for_client: "Available for client",
  l_Type: "Type",
  l_Template: "Template",
  l_Attached_file: "Attached file",
  l_Document_number: "Document number",
  l_Document_date: "Document date",
  l_Provide_access_to_the_client: "Provide access to the client",
  l_File: "File",
  l_OverheadDocuments: "Overhead documents",
  l_Tags: "Tags",
  l_Rail_trips: "Rail trips",
  l_OtherDocuments: "Other documents",
  l_Acts: "Acts",
  l_Photos: "Photos",
  l_Link: "Link",
  l_To_comment: "To comment",
  l_Comment: "Comment",
  l_Cargo: "Cargo",
  l_Place: "Place",
  l_ETA: "ETA",
  l_Sent: "Sent",
  l_Author: "Author",
  l_Trip_type: "Trip type",
  l_Neutral: "Neutral",
  l_Finish: "Finish",
  l_Change_the_status_of_cargo_on_this_flight:
    "Change the status of cargo on this flight",
  l_Are_you_sure_you_want_to_update: "Are you sure you want to update?",
  l_Finance_template: "Finance template",
  l_Wagon_data: "Wagon data",
  l_New_country: "New country",
  l_Default_country: "Default country",
  l_Train_Trip_number: "Train/Trip number",
  l_Car_Container_number: "Car/Container number",
  l_Cargo_data: "Cargo data",
  l_GNG_code: "GNG code",
  l_Classes_of_transport_rates: "Classes of transport rates",
  l_Rules_for_using_the_car: "Rules for using the car",
  l_Wagon_renter: "Wagon renter",
  l_Freight_with_VAT: "Freight with VAT",
  l_Login_: "Login",
  l_Close: "Close",
  l_Directions: "Directions",
  l_Add_cargo: "Add cargo",
  l_Comment_type: "Comment type",
  l_Provide_access_to_carrier: "Provide access to carrier",
  l_From: "From",
  l_Countries: "Countries",
  l_Drivers_name: "Driver's name",
  l_Drivers_surname: "Driver's surname",
  l_Middle_name: "Middle name",
  l_Passport: "Passport",
  l_Driving_licence_number: "Driving licence number",
  l_Driving_licence_categories: "Driving licence categories",
  l_Fuel_card: "Fuel card",
  l_Is_active: "Is active",
  l_Bank_account: "Bank account",
  l_Contact_type: "Contact type",
  l_Export_to_excel: "Excel",
  l_Vehicle: "Vehicle",
  l_Shipment: "Shipment",
  l_Change_group_cargo_status: "Change cargo status by group",
  l_Transportation: "Transportation documents",
  l_Price_and_payment_term: "Price and payment term",
  l_Issued_invoice: "Issued invoice",
  l_Overhead: "Overhead documents",
  l_Freezing_order: "Freezing order",
  l_Additional_expenses: "Additional expenses",
  l_Trip_costs: "Trip costs",
  l_Unrecorded_expenses:
    "Unrecorded expenses - expenses marked with the checkbox 'unaccounted expenses'",
  l_Specifications: "Specifications",
  l_Copying: "Copying",
  l_Apply: "Apply",
  l_updateStatus: "Update status",
  l_Date_of_employment: "Date of employment",
  l_Euro_emission_class: "Euro emission class",
  l_Trailer_number: "Trailer number",
  l_Brand: "Brand",
  l_Cargo_price: "Cargo price",
  l_Expense_templates: "Expense template",
  l_Model: "Model",
  l_Rail_stations: "Rail stations",
  l_Production_date: "Production date",
  l_Body_number: "Body number",
  l_Registration_date: "Registration date",
  l_Tech_passport_validity: "Tech passport validity",
  l_License_number: "License number",
  l_License_validity_date: "License validity date",
  l_Drivers: "Drivers",
  l_Transport_information: "Transport information",
  l_Vehicle_empty_weight: "Vehicle empty weight",
  l_Vehicle_full_weight: "Vehicle full weight",
  l_Vehicle_axels: "Vehicle axels",
  l_New_company: "New company",
  l_Max_weight: "Max weight",
  l_Max_euro_pallets: "Max euro pallets",
  l_Relevant_documents: "Relevant documents",
  l_Document_groups: "Document groups",
  l_Template_name: "Template name",
  l_Is_default: "Is default",
  l_Service_type: "Service type",
  l_Statistical: "Statistical",
  l_New_contact_person: "New contact person",
  l_Statistic: "Statistic",
  l_Unregistered: "Unregistered",
  l_Role: "Role",
  l_Permission: "Permission",
  l_Description: "Description",
  l_Peromission_key: "Permission key",
  l_Parent_option: "Parent option",
  l_Level: "Level",
  l_Border_point: "Border point",
  l_Cost_per_cargo: "Cost per cargo",
  l_By_weight: "By weight",
  l_By_volume: "By volume",
  l_By_weight_and_volume: "By weight and volume",
  l_Batch_setting_cargo_status: "Batch setting cargo status",
  l_Selected: "Selected",
  l_not_selected: "Not selected",
  l_Distribute_percent: "Distribute percent",
  l_Distribute_price: "Distribute price",
  l_Total: "Total",
  l_Clear: "Clear",
  l_By: "By",
  l_Add_date: "Add date",
  l_Update_date: "Update date",
  l_Descending: "Descending",
  l_Ascending: "Ascending",
  l_Invoice: "Invoice",
  l_Invoices_issued: "Invoices issued",
  l_invoiceNumber: "Invoice Number",
  l_senderInvoice: "Company",
  l_issuedDate: "Invoice issued",
  l_receivingDate: "Date of receiving",
  l_payUntilDate: "Pay until",
  l_Trip_status: "Trip status",
  l_Without_VAT: "Without VAT",
  l_With_VAT: "With VAT",
  l_Change_order_status: "Change order status",
  l_Invoice_line: "Invoice line",
  l_Unit: "Unit",
  l_Received_from: "Received from",
  l_Company_which_received_the_invoice: "Company, which received the invoice",
  l_Breaking_rule: "Breaking rule",
  l_Contractor: "Contractor",
  l_Empty: "Empty",
  l_No_data: "No data",
  l_Payer: "Payer",
  l_Language: "Language",
  l_Made: "Made",
  l_Notes: "Notes",
  l_Devider: "Devider",
  l_Element: "Element",
  l_Percent: "Percent",
  l_INN_EGRPOU_VAT_BIN_UNN: "INN, EGRPOU, VAT, BIN, UNN",
  l_Start: "Start",
  l_End: "End",
  l_Contract_date: "Contract date",
  l_Contract_number: "Contract number",
  l_Has_contract: "Has contract",
  l_Contragents: "Contragents",
  l_Issued_invoice_in_order: "Issued invoice in order",
  l_Status_history: "Status history",
  l_New_request: "New request",
  l_Classifier_section: "Classifier section",
  l_Add_places: "Add route from cargo",
  l_Client_type_definition:
    "Client types - classification of Clients by importance/urgency. Filled out in the Client card and interacts with Requests. When filling out the directory, you can set the priority of the segment. This figure determines the importance and position of the Request from a client with this Type. It works like this: add VIP Client Type to the directory, segment priority is 1. Next, in the card of the desired Client, select this type and all requests from this Client will be located at the very top of the general Requests table, regardless of the order in which they were received. You can also use a filter in the Clients block to make a selection by Clients of a certain Type.",
  l_Company_is_required: "Select company",
  l_File_is_required: "Upload files",
  l_Comment_is_required: "Enter comment",
  l_Contract_is_required: "Select contract",
  l_Company_name_is_required: "Enter company name",
  l_Business_number_is_required: "Enter number",
  l_Required_field: "Required field",
  l_Select_required: "Select value",
  l_Type_to_search_orders: "Type to search orders",
};
